import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';

import { redirect } from 'redpoints-front-common/helpers';

import {
  facilitatorValidationFetchNext,
  facilitatorValidationSetSelectedFilters,
} from '../../../actions/facilitatorValidationActions';
import { ROUTES } from '../../../config/constants';

/**
 * Perform fetch initial facilitator validation and add the filterByCustomer to the query params of the url if filterByTenant is disabled
 */
const useLoadInitialFacilitatorValidation = ({
  castedQueryParams,
  customerId,
  isEnableFilterByTenant,
}) => {
  const dispatch = useDispatch();

  const [initialCastedQueryParams] = useState(castedQueryParams);

  const filterByCustomer =
    initialCastedQueryParams.filterByCustomer || !isEnableFilterByTenant;

  const mustFetchInitialLink =
    !isEmpty(initialCastedQueryParams) && isEnableFilterByTenant != null;

  useEffect(() => {
    if (mustFetchInitialLink) {
      dispatch(
        facilitatorValidationSetSelectedFilters({
          domainId: initialCastedQueryParams.domainId,
          filterByCustomer,
        })
      );

      const customerIdToFetch = filterByCustomer ? customerId : undefined;
      dispatch(
        facilitatorValidationFetchNext({
          customerId: customerIdToFetch,
          domainId: initialCastedQueryParams.domainId,
        })
      );
    }
  }, [
    customerId,
    dispatch,
    filterByCustomer,
    initialCastedQueryParams.domainId,
    initialCastedQueryParams.filterByCustomer,
    mustFetchInitialLink,
  ]);

  const mustRedirect =
    isEnableFilterByTenant != null &&
    !isEmpty(initialCastedQueryParams) &&
    initialCastedQueryParams.filterByCustomer !== filterByCustomer;

  useEffect(() => {
    if (mustRedirect) {
      redirect({
        queryParams: { ...initialCastedQueryParams, filterByCustomer },
        urlRoute: ROUTES.FACILITATOR_VALIDATION,
      });
    }
  }, [filterByCustomer, initialCastedQueryParams, mustRedirect]);
};

export default useLoadInitialFacilitatorValidation;
